import API from './api';

function urlBase64ToUint8Array(base64) {
  const padding = '='.repeat((4 - base64.length % 4) % 4);
  const base = (base64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base);
  const out = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) out[i] = raw.charCodeAt(i);
  return out;
}

let inited = false;
let unloadHandler = null;

export async function initPush() {
  if (inited) return;
  inited = true;

  if (!('serviceWorker' in navigator) || !('PushManager' in window) || !('Notification' in window)) return;
  if (!localStorage.getItem('token')) return;

  // Wait for the SW to be ready
  let registration;
  try {
    registration = await navigator.serviceWorker.ready;
  } catch { return; }

  // Ask permission if not yet granted/denied
  if (Notification.permission === 'default') {
    try { await Notification.requestPermission(); } catch {}
  }
  if (Notification.permission !== 'granted') return;

  // Get VAPID public key from backend
  let vapidKey = '';
  try {
    const r = await API.get('/push/vapid-public');
    vapidKey = r.data?.key || '';
  } catch { return; }
  if (!vapidKey) return;

  let subscription;
  try {
    subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      // Re-check the key matches; if not, resubscribe
      const existingKey = subscription.options?.applicationServerKey;
      if (!existingKey) {
        await subscription.unsubscribe().catch(() => {});
        subscription = null;
      }
    }
    if (!subscription) {
      subscription = await registration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(vapidKey),
      });
    }
  } catch (e) {
    console.warn('push subscribe failed:', e);
    return;
  }

  const json = subscription.toJSON();
  try {
    await API.post('/push/subscribe', {
      endpoint: json.endpoint,
      keys: json.keys,
    });
  } catch (e) {
    console.warn('push subscribe POST failed:', e?.response?.status);
  }
}

export async function disablePush() {
  if (!('serviceWorker' in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    if (sub) {
      try { await API.post('/push/unsubscribe', { endpoint: sub.endpoint }); } catch {}
      await sub.unsubscribe().catch(() => {});
    }
  } catch {}
}
